<script setup lang="ts">
import { onMounted, reactive, ref, nextTick } from "vue";
import headComponent from "./head.vue";
import footComponent from "./foot.vue";
import { ElScrollbar } from "element-plus";
import * as api from "@/api";
const pageSrc = reactive({
  log: "页面创建了",
  logo: [] as any,
});

const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>();
onMounted(() => {
  console.log(pageSrc.log);
  getLogo();
});
/**
 * 返回顶部
 */
const toTop = () => {
  (scrollbarRef as any).value.setScrollTop(0);
};
/**
 * 滚动到底部
 */
const scrollToBottom = () => {
  nextTick(() => {
    const scrollbar = scrollbarRef.value;
    if (scrollbar) {
      const wrap = scrollbar.$el?.querySelector(".el-scrollbar__wrap");
      if (wrap) {
        const totalHeight = wrap.scrollHeight;
        const currentTop = wrap.scrollTop;
        const distance = totalHeight - currentTop;
        const duration = 1000; // 增加总持续时间
        const startTime = performance.now();

        const animateScroll = (currentTime: number) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);

          // 使用easeInOutCubic缓动函数：先快后慢
          let easeProgress;
          if (progress < 0.5) {
            // 前半段：快速加速
            easeProgress = 4 * progress * progress * progress;
          } else {
            // 后半段：缓慢减速
            const adjustedProgress = 2 * progress - 2;
            easeProgress =
              0.5 * adjustedProgress * adjustedProgress * adjustedProgress + 1;
          }

          const scrollPosition = currentTop + distance * easeProgress;
          scrollbar.setScrollTop(scrollPosition);

          if (progress < 1) {
            requestAnimationFrame(animateScroll);
          }
        };

        requestAnimationFrame(animateScroll);
      }
    }
  });
};
const getLogo = async () => {
  try {
    const res = await api.getAdImgAndVideo(48);
    pageSrc.logo = res?.data.ad_list[0].pic;
  } catch (e) {
    console.error(e);
  }
};
</script>
<template>
  <el-scrollbar class="elBar" ref="scrollbarRef">
    <div class="mainPage XhorizontalCenter">
      <headComponent :logo="pageSrc.logo" @scrollToBottom="scrollToBottom" />
      <router-view v-slot="{ Component }">
        <transition mode="in-out">
          <keep-alive>
            <div class="content XhorizontalCenter">
              <component class="content_box" :is="Component" />
            </div>
          </keep-alive>
        </transition>
      </router-view>
      <footComponent @toTop="toTop" :logo="pageSrc.logo" />
    </div>
  </el-scrollbar>
</template>
<style lang="scss" scoped>
.elBar {
  height: 100vh;
}

.mainPage {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  .content {
    width: 100%;
    background-color: #fff;
    min-height: calc(100vh - calc(360px + 266px));

    &_box {
      width: 100%;
      padding: 0;
      margin: 0;
      z-index: 1;
      min-height: calc(100vh - calc(550px + 250px));
      background-color: rgb(235, 133, 150);
    }
  }
}
</style>
